module.exports = __webpack_public_path__ + "img/home_62.55a9bc17.svg";